import pictures from '../../assests/assestimport.js';
const {hp} = pictures;

console.log(hp);
const hats=[
    {
        id:1,
        label:'3M™ WHITE 3MH-701R HELMET',
        band:"3M",
        description:`3M™ HELMET WITH RATCHET SUSPENSION                      
        CLASS C,G & E  ELECTRICAL PROTECTION AGAINST 20000 VOLTS`,
        image:hp[0],
        alt:"Hats",
        hscode:'65061010',
    },
    {
        id:2,
        label:'3M™ VENTILATED HELMET 3MH-701V',
        band:"3M",
        description:`3M™ VENTILATED HELMET WITH RATCHET SUSPENSION  CLASS C
        FEATURES : Ventilated, 4 Points Ratchet Suspension, Accessory Slots, Replaceable Brow Pad, Short Brim For Better Upward Visibility, Customized Logo Options, Comfortable, Tough and Lightweight.
        MATERIAL : HDPE
        COLOR : White`,
        image:hp[1],
        alt:"3M Ventilated Helmet with Ratchet Suspension 3M-701V",
        hscode:'65061010',
    },
    {
        id:3,
        label:'GREEN 704R',
        band:"3M",
        description:`3M™ HELMET WITH RATCHET SUSPENSION                      
        CLASS C,G & E  ELECTRICAL PROTECTION AGAINST 20000 VOLTS     
        FEATURES : 4 Points Ratchet Suspension, Accessory Slots, Replaceable Brow Pad, Short Brim For Better Upward Visibility, Customized Logo Options, Comfortable, Tough and Lightweight.
        MATERIAL : HDPE
        COLOR : White, Yellow, Blue, Red, Orange, Green`,
        image:hp[2],
        alt:"3M green 704R 3M helmet with ratchet suspension hat",
        hscode:'65061010',
    },
    {
        id:4,
        label:'MSA V-GARD - NON VENTED',
        band:"MSA",
        description:`MSA SAFETY HELMET WITH RATCHET SUSPENSION 
        Features: UV stabilised ABS helmet shell offering good resistance to scratches
        Provides lateral crush protection
        Built-in rain gutter for outdoor operations
        Ideal design for adapting earmuffs, visors or attaching headband of MSA
        Colors: White, Yellow, Blue, Orange, Green, Red
        Material: HDPEwith UV inhibitor
        Type I, Class G, E & C
        GOST certified (–50°C)
        Applications:
        For many industrial applications the ideal and most economic solution`,
        image:hp[3],
        alt:"MSA V-Gard - Non Vented Safety Helmet with Ratchet Suspension hat",
        hscode:'65061010',
    },
    {
        id:5,
        label:'MSA V GARD 500- VENTED HARD HAT',
        band:"MSA",
        description:`MSA VENTED SAFETY HELMET WITH RATCHET SUSPENSION
        Comfort and protection
        UV stabilised ABS helmet shell offering good resistance to scratches
        Provides lateral crush protection
        Built-in rain gutter for outdoor operations
        Ideal design for adapting earmuffs, visors or attaching headband of MSA
        V-Gard 500 helmet can be delivered with a badge holder on the front
        Ventilation holes on the upper part for optimized airflow
        Material: HDPE
        Colors: White
        Type 1 Class C`,
        image:hp[4],
        alt:"MSA V Gard 500- Vented Hard Hat Safety Helmet with Ratchet Suspension hat",
        hscode:'65061010',
    },
    {
        id:6,
        label:'3MH801R',
        band:"3M",
        description:`3M™ FULL BRIM HELMET WITH RATCHET SUSPENSION 
        FEATURES : Comfortable Suspension Sits Lower On Head To Reduce Pressure Points, 4-Points Smooth And Easy Turning Ratchet Suspension, Absorbent Brow Pad, Offers Extra Shielding From The Sun, Splashes, Rain, Sleet, Snow etc, Often Preferred In Hot And Sunny Locations,  
        APPLIED INDUSTRIES : Heavy And Light Industrial, Construction, Oil And Gas, Road Works, Utilities, Forestry, Mining Etc.
        Color: White`,
        image:hp[5],
        alt:"3M H801R Full Brim Helmet with Ratchet Suspension hat",
        hscode:'65061010',
    },
    {
        id:7,
        label:'MSA FULL BRIM',
        band:"MSA",
        description:`MSA V-Gard Full Brim helmet W/Ratchet suspension
        Superior top impact protection
        Fas-Trac III suspension is the most comfortable
        CLASSIFICATION Type I, Class E
        APPLICATION(S) General Purpose
        SHELL MATERIAL Virgin high-density polyethylene (HDPE)
        with UV inhibitor
        Colors: White, Yellow`,
        image:hp[6],
        alt:"MSA Full Brim Safety Helmet with Ratchet Suspension hat",
        hscode:'65061010',
    },
    {
        id:8,
        label:'BULLARD LTX SERIES',
        band:"BULLARD",
        description:`BULLARD HELMET (FIRE FIGHTING HELMET)
        Heat-Resistant Thermoplastic, Ratchet Adjustment, Hard-Coated High Heat Thermoplastic, 
        Material Facesheild, Meets Standard for Eye and Face Protection`,
        image:hp[7],
        alt:"Bullard LTX Series Safety Helmet hat",
        hscode:'65061090',
    },
    {
        id:9,
        label:'BULLARD S61',
        band:"BULLARD",
        description:`Bullard Helmet with RatchetBullard S61 conform to all ANSI/ISEA Z89.1-2014,
        Type I, Class E & G requirements, including impact,
        penetration, and electrical insulation. Available with
        a 4-point self-sizing pinlock. Made from high-density
        polyethylene.
        Available Colors: Yellow, White, Blue, Red, Green, etc`,
        image:hp[8],
        alt:"Bullard S61 Safety Helmet hat",
        hscode:'',
    },
    {
        id:10,
        label:'BULLARD S62',
        band:"BULLARD",
        description:`Bullard Helmet with Ratchet W Vent
        Bullard S62 is the Standard Series vented hard hat
        4-point Ratchet suspension system with cotton absorbent brow pad
        Vented shell design for increased ventilation and worker comfort
        ANSI/ISEA Classification: Z89.1-2014, Type I, Class C
        Made in USA`,
        image:hp[9],
        alt:"Bullard S62 Safety Helmet hat",
        hscode:'',
    },
    {
        id:11,
        label:'BULLARD S71',
        band:"BULLARD",
        description:`Bullard Full Brim Helmet with Ratchet
        A wide brim extends the area of rain and sun protection offered by the Model S71 Hard Hat
        Highly absorbent cotton replaceable brow pad for added comfort
        Four-point suspension has a Flex-Gear® ratchet suspension with a ratchet sizing knob and flex points for a personal fit
        Accessory slots allow for mounting faceshields, welding helmets, earmuffs and headsets
        Meets ANSI Z89.1-2014, Type I, Class E and G requirements
        Made in USA`,
        image:hp[10],
        alt:"Bullard S71 Full Brim Safety Helmet with Ratchet Suspension hat",
        hscode:'',
    },
]

export default hats;